'use client';

import { NavLink } from './NavLink';
import { getAnchorIds, resolveHref, resolveMetaNavClassName } from './navigation.utils';
import { useScrollSpy } from '@/hooks';
import { usePathname } from 'next/navigation';
import { useSiteSettings } from '@/components/providers';

type RestProps = {
    className?: string;
};

export function NavigationMeta({ className }: RestProps) {
    const settings = useSiteSettings();
    const items = settings.navigation?.meta ?? [];
    const pathname = usePathname();
    const anchorIds = getAnchorIds(items);
    const activeAnchorId = useScrollSpy({ ids: anchorIds });

    return (
        <nav className={className} aria-label="Main navigation">
            <ul className="flex gap-5 justify-end md:gap-8">
                {items.map((item) => {
                    const href = resolveHref(item);
                    const isAnchor = Boolean(item.anchor);
                    const isActive = isAnchor ? item.anchor === activeAnchorId : pathname === href;

                    return (
                        <li key={item._key} className="flex items-center">
                            <NavLink item={item} isActive={isActive} className={resolveMetaNavClassName(item)} />
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
}
